function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { activeAnimations } from './animation-count.mjs';
import { statsBuffer } from './buffer.mjs';
import { frame, cancelFrame, frameData } from '../frameloop/frame.mjs';

function record() {
  var value = statsBuffer.value;

  if (value === null) {
    cancelFrame(record);
    return;
  }

  value.frameloop.rate.push(frameData.delta);
  value.animations.mainThread.push(activeAnimations.mainThread);
  value.animations.waapi.push(activeAnimations.waapi);
  value.animations.layout.push(activeAnimations.layout);
}

function mean(values) {
  return values.reduce(function (acc, value) {
    return acc + value;
  }, 0) / values.length;
}

function summarise(values) {
  var calcAverage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mean;

  if (values.length === 0) {
    return {
      min: 0,
      max: 0,
      avg: 0
    };
  }

  return {
    min: Math.min.apply(Math, _toConsumableArray(values)),
    max: Math.max.apply(Math, _toConsumableArray(values)),
    avg: calcAverage(values)
  };
}

var msToFps = function msToFps(ms) {
  return Math.round(1000 / ms);
};

function clearStatsBuffer() {
  statsBuffer.value = null;
  statsBuffer.addProjectionMetrics = null;
}

function reportStats() {
  var value = statsBuffer.value;

  if (!value) {
    throw new Error("Stats are not being measured");
  }

  clearStatsBuffer();
  cancelFrame(record);
  var summary = {
    frameloop: {
      setup: summarise(value.frameloop.setup),
      rate: summarise(value.frameloop.rate),
      read: summarise(value.frameloop.read),
      resolveKeyframes: summarise(value.frameloop.resolveKeyframes),
      preUpdate: summarise(value.frameloop.preUpdate),
      update: summarise(value.frameloop.update),
      preRender: summarise(value.frameloop.preRender),
      render: summarise(value.frameloop.render),
      postRender: summarise(value.frameloop.postRender)
    },
    animations: {
      mainThread: summarise(value.animations.mainThread),
      waapi: summarise(value.animations.waapi),
      layout: summarise(value.animations.layout)
    },
    layoutProjection: {
      nodes: summarise(value.layoutProjection.nodes),
      calculatedTargetDeltas: summarise(value.layoutProjection.calculatedTargetDeltas),
      calculatedProjections: summarise(value.layoutProjection.calculatedProjections)
    }
  };
  /**
   * Convert the rate to FPS
   */

  var rate = summary.frameloop.rate;
  rate.min = msToFps(rate.min);
  rate.max = msToFps(rate.max);
  rate.avg = msToFps(rate.avg);
  var _ref = [rate.max, rate.min];
  rate.min = _ref[0];
  rate.max = _ref[1];
  return summary;
}

function recordStats() {
  if (statsBuffer.value) {
    clearStatsBuffer();
    throw new Error("Stats are already being measured");
  }

  var newStatsBuffer = statsBuffer;
  newStatsBuffer.value = {
    frameloop: {
      setup: [],
      rate: [],
      read: [],
      resolveKeyframes: [],
      preUpdate: [],
      update: [],
      preRender: [],
      render: [],
      postRender: []
    },
    animations: {
      mainThread: [],
      waapi: [],
      layout: []
    },
    layoutProjection: {
      nodes: [],
      calculatedTargetDeltas: [],
      calculatedProjections: []
    }
  };

  newStatsBuffer.addProjectionMetrics = function (metrics) {
    var layoutProjection = newStatsBuffer.value.layoutProjection;
    layoutProjection.nodes.push(metrics.nodes);
    layoutProjection.calculatedTargetDeltas.push(metrics.calculatedTargetDeltas);
    layoutProjection.calculatedProjections.push(metrics.calculatedProjections);
  };

  frame.postRender(record, true);
  return reportStats;
}

export { recordStats };